<template>
  <SalesDashboardCard title="Top 5 companies" class-card="col-md-4" @set-filter="setFilter" :selected-filter="selectedFilter" :filters="filters">
    <div slot="body">
      <Loader v-if="loading" />
      <div v-else>
        <div class="d-flex align-items-center">
          <span class="legend mr-3">
            <span class="legend-claim" />
            Claims
          </span>
          <span class="legend">
            <span class="legend-job" />
            Jobs
          </span>
        </div>
        <div class="mt-3 d-flex flex-column">
          <div v-for="company in companies" :key="company.company_id" class="top-company-wrap row">
            <div class="col-5">
              <span class="company-name">{{ company.company_name }}</span>
            </div>
            <div class="col-2 d-flex align-items-center">
              <svg data-v-21f5376e="" data-v-34cbeed1="" height="14" width="14" viewBox="0 0 14 14" class="vue-star-rating-star" step="10"><linearGradient data-v-21f5376e="" id="o8z3ss" x1="0" x2="100%" y1="0" y2="0"><stop data-v-21f5376e="" offset="100%" stop-color="#ffd055" /> <stop data-v-21f5376e="" offset="100%" stop-color="#d8d8d8" /></linearGradient> <filter data-v-21f5376e="" id="y3cylm" height="130%" width="130%" filterUnits="userSpaceOnUse"><feGaussianBlur data-v-21f5376e="" stdDeviation="0" result="coloredBlur" /> <feMerge data-v-21f5376e=""><feMergeNode data-v-21f5376e="" in="coloredBlur" /> <feMergeNode data-v-21f5376e="" in="SourceGraphic" /></feMerge></filter> <polygon data-v-21f5376e="" points="6.363636363636363,0.7070707070707071,2.121212121212121,14,12.727272727272727,5.515151515151515,0,5.515151515151515,10.606060606060606,14" fill="url(#o8z3ss)" stroke="#fff" filter="url(#y3cylm)" /> <polygon data-v-21f5376e="" points="6.363636363636363,0.7070707070707071,2.121212121212121,14,12.727272727272727,5.515151515151515,0,5.515151515151515,10.606060606060606,14" fill="url(#o8z3ss)" stroke="#999" stroke-width="0" stroke-linejoin="miter" /> <polygon data-v-21f5376e="" points="6.363636363636363,0.7070707070707071,2.121212121212121,14,12.727272727272727,5.515151515151515,0,5.515151515151515,10.606060606060606,14" fill="url(#o8z3ss)" /></svg>
              <span class="company-rating">{{ company.rating }}</span>
            </div>
            <div class="col-5 d-flex align-items-center">
              <div class="w-50 d-flex align-items-center mr-1">
                <div class="w-100 d-flex align-items-center justify-content-end mr-2">
                  <div class="claim-progress position-relative" :style="{width: `${calculateClaimPercentForProgress(company.count_claims)}%`}">
                    <span class="counter-claims">{{ company.count_claims }}</span>
                  </div>
                </div>
              </div>
              <div class="w-50 d-flex align-items-center">
                <div class="w-100">
                  <div class="job-progress position-relative" :style="{width: `${calculateJobPercentForProgress(company.count_jobs)}%`}">
                    <span class="counter-jobs">{{ company.count_jobs }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SalesDashboardCard>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import SalesDashboardCard from '../SalesDashboardCard';
import Loader from './Loader';

const filters = [
  {
    name: 'Today',
    date: '',
    to: moment().format('YYYY-MM-DD'),
    from: moment().format('YYYY-MM-DD'),
  },
  {
    name: 'Yesterday',
    date: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    from: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last week',
    date: '',
    from: moment()
      .subtract(1, 'weeks')
      .weekday(1)
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'weeks')
      .weekday(7)
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last month',
    date: '',
    from: moment()
      .subtract(1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('YYYY-MM-DD'),
  },
];

export default {
  components: { Loader, SalesDashboardCard },
  data() {
    return {
      companies: [],
      loading: false,
      filters,
      selectedFilter: filters[2],
    };
  },
  computed: {
    maxCountClaims() {
      let max = 0;
      this.companies.forEach(claim => {
        if (max < claim.count_claims) {
          max = claim.count_claims;
        }
      });

      return max;
    },
    maxCountJobs() {
      let max = 0;
      this.companies.forEach(claim => {
        if (max < claim.count_jobs) {
          max = claim.count_jobs;
        }
      });

      return max;
    },
  },
  watch: {
    selectedFilter() {
      this.getTopCompanies();
    },
  },
  mounted() {
    this.getTopCompanies();
  },
  methods: {
    getTopCompanies() {
      this.loading = true;
      axios
        .get(
          `/sales/top-companies?date=${this.selectedFilter.date}&date_from=${
            this.selectedFilter.from
          }&date_to=${this.selectedFilter.to}`,
        )
        .then(res => {
          this.companies = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setFilter(filter) {
      this.selectedFilter = filter;
    },
    calculateClaimPercentForProgress(claims) {
      if (claims <= 0) {
        return 5;
      }

      if (this.maxCountClaims > 0) {
        const onePercent = this.maxCountClaims / 100;
        return claims / onePercent;
      }

      return 5;
    },
    calculateJobPercentForProgress(jobs) {
      if (jobs <= 0) {
        return 5;
      }

      if (this.maxCountJobs > 0) {
        const onePercent = this.maxCountJobs / 100;
        return jobs / onePercent;
      }

      return 5;
    },
  },
};
</script>

<style lang="scss" scoped>
.legend {
  display: inline-block;
  font-size: 0.7rem;
  color: #c5c5c5;

  span {
    width: 8px;
    height: 8px;
    border-radius: 4px;
  }
}

.legend-claim {
  background-color: #fd2979;
  display: inline-block;
}

.legend-job {
  background-color: #2978fe;
  display: inline-block;
}

.company-name {
  font-size: 0.7rem;
  color: black;
}

.company-rating {
  font-size: 0.7rem;
  color: black;
  display: inline-block;
  margin-left: 5px;
}

.counter-claims {
  margin-right: 5px;
  font-size: 0.7rem;
  font-weight: bold;
  color: black;
  position: absolute;
  right: 100%;
}

.counter-jobs {
  margin-left: 5px;
  font-size: 0.7rem;
  font-weight: bold;
  color: black;
  position: absolute;
  left: 100%;
}

.claim-progress {
  background-color: #fd2979;
  border-radius: 5px;
  height: 10px;
  display: flex;
  align-items: center;
}

.job-progress {
  background-color: #0f46e1;
  border-radius: 5px;
  height: 10px;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/cards/TopCompanies.vue